import { useQuery } from "@tanstack/react-query";

import { getUser } from "@services/user";

export const useUser = (id: string, options: Record<string, any> = {}) => {
  return useQuery<any>({
    queryKey: ["users", id],
    queryFn: () => getUser(id),
    enabled: !!id,
    ...options,
  });
};
